// Blow Exhaust JS

$(document).ready(function() {
 
 	 var screenSize = $( window ).width();

 	//owl carousel
	$("#homepage-slider").owlCarousel({ 
	  autoPlay: 3000, //Set AutoPlay to 3 seconds
      navigation : false, // Show next and prev buttons
      slideSpeed : 300,
      paginationSpeed : 400,
      singleItem:true
	});


	// open modal in product page. bulk discount
	$("#bulk-modal").on("click", function(){
		$("body").addClass("no-scroll");
		$(".blow-modal-overlay").fadeIn(300);
		$(".modal-bulk").fadeIn(300);
	});

	$(".blow-modal-overlay, .blow-modal-overlay i, .modal-close-btn").on("click", function(){
		$("body").removeClass("no-scroll");
		$(".blow-modal-overlay").fadeOut(300);
		$(".blow-modal-container").fadeOut(200);
	});

  
  	$('body').on('click', '[name="checkout"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        $("body").addClass("no-scroll");
		$(".blow-modal-overlay").fadeIn(300);
		$(".modal-agree").fadeIn(300);
        return false;
      }
    });

});




